import { render, staticRenderFns } from "./product-template-filter.component.vue?vue&type=template&id=45972b72&scoped=true&"
import script from "./product-template-filter.component.vue?vue&type=script&lang=ts&"
export * from "./product-template-filter.component.vue?vue&type=script&lang=ts&"
import style0 from "./product-template-filter.component.vue?vue&type=style&index=0&id=45972b72&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45972b72",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
